module.exports = __webpack_public_path__ + "images/logo-blue@2x_0ebf2655a6ad46e5bd35ac4b2c63de35.png";